<template>
    <section class="min-vh-100 d-flex">
        <div class="row g-0 overflow-hidden w-100 shadow rounded">
            <div class="col-lg-5 col-md-12 col-sm-12 signup-image">
                <div class="image"></div>
            </div>
            <div class="col-lg-7 col-md-12 col-sm-12  container-3">
                <div class=" mx-auto ">
                    <div class="d-flex flex-column content-login align-items-flex-start px-5 mx-5">
                        <div class="info">
                            <router-link to="/">
                                <img src="../../assets/images/home/sign-up-logo.svg" alt="" class="img-fluid">
                            </router-link>
                            <h3 class="text text-capitalize">
                                {{ $t('sign_up') }}
                            </h3>
                            <p class="my-3">
                                <span class="d-inlin-block mb-2"> {{ $t('already_have_account') }} </span> <br />
                                <span>
                                    {{ $t('login_here') }}
                                    <router-link to="/login" class="signup-button"> <strong> {{ $t('login_here1') }}
                                        </strong>
                                    </router-link>
                                </span>
                            </p>
                        </div>
                    </div>
                    <form id="formAuthentication" class="mt-3 mx-5" @submit.prevent="submitSignUp" novalidate>
                        <!----------Email------------------------>
                        <div class="row">
                            <div class="col mb-24">
                                <span class="text-capitalize">{{ $t('email') }}</span>
                                <div class="form-control position-relative">
                                    <input type="email" :placeholder="$t('form.email')" aria-label="email"
                                        v-model="userEmail" class="w-100 svg-fill">
                                    <label class="user-first">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17"
                                            viewBox="0 0 18 17" fill="none">
                                            <g clip-path="url(#clip0_1398_5610)">
                                                <path
                                                    d="M1.49755 2.67651H15.5419C16.3677 2.67651 17.0396 3.34679 17.0396 4.17065V12.8294C17.0396 13.6533 16.3677 14.3236 15.5419 14.3236H1.49755C0.671758 14.3236 -7.62939e-05 13.6533 -7.62939e-05 12.8294V4.17065C-7.62939e-05 3.34679 0.671758 2.67651 1.49755 2.67651ZM1.693 3.67261L1.89289 3.83866L7.92555 8.85037C8.26987 9.13638 8.76967 9.13638 9.11393 8.85037L15.1466 3.83866L15.3465 3.67261H1.693ZM16.0411 4.39172L11.1259 8.47514L16.0411 11.7388V4.39172ZM1.49755 13.3275H15.5419C15.7831 13.3275 15.9849 13.1559 16.0311 12.9287L10.3253 9.14017L9.75278 9.61583C9.39555 9.9126 8.95761 10.061 8.5197 10.061C8.0818 10.061 7.64389 9.9126 7.28663 9.61583L6.71407 9.14017L1.00832 12.9286C1.05458 13.1559 1.25633 13.3275 1.49755 13.3275ZM0.998339 11.7388L5.91361 8.47517L0.998339 4.39172V11.7388Z"
                                                    fill="#0F1030" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1398_5610">
                                                    <rect width="17.0396" height="17" fill="white"
                                                        transform="matrix(-1 0 0 1 17.0396 0)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </label>
                                </div>
                                <span class="errorMessage text-danger" v-if="v$.userEmail.$error">
                                    {{ v$.userEmail.$errors[0].$message }}
                                </span>
                            </div>
                        </div>
                        <!------user Name----------->
                        <div class="row">
                            <div class="col mb-24">
                                <span class="text-capitalize">{{ $t('username') }}</span>
                                <div class="form-control position-relative">
                                    <label class="user-first">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 16 16" fill="none">
                                            <path
                                                d="M7.88599 7.70726C8.94482 7.70726 9.86157 7.3275 10.6108 6.57823C11.3599 5.82909 11.7397 4.91247 11.7397 3.85351C11.7397 2.79492 11.36 1.87817 10.6107 1.12878C9.86145 0.37976 8.9447 0 7.88599 0C6.82703 0 5.9104 0.37976 5.16125 1.1289C4.41211 1.87805 4.03223 2.79479 4.03223 3.85351C4.03223 4.91247 4.41211 5.82921 5.16125 6.57836C5.91064 7.32738 6.82739 7.70726 7.88599 7.70726ZM5.82434 1.79187C6.39917 1.21704 7.07349 0.93762 7.88599 0.93762C8.69836 0.93762 9.3728 1.21704 9.94775 1.79187C10.5226 2.36682 10.8021 3.04125 10.8021 3.85351C10.8021 4.66601 10.5226 5.34032 9.94775 5.91527C9.3728 6.49022 8.69836 6.76964 7.88599 6.76964C7.07373 6.76964 6.39941 6.4901 5.82434 5.91527C5.24939 5.34044 4.96985 4.66601 4.96985 3.85351C4.96985 3.04125 5.24939 2.36682 5.82434 1.79187Z"
                                                fill="#0F1030" />
                                            <path
                                                d="M14.629 12.3031C14.6074 11.9913 14.5637 11.6512 14.4994 11.2921C14.4344 10.9303 14.3508 10.5883 14.2507 10.2756C14.1472 9.95251 14.0067 9.63342 13.8328 9.32763C13.6525 9.01025 13.4406 8.73388 13.2028 8.50647C12.9541 8.26855 12.6497 8.07727 12.2976 7.93774C11.9468 7.79895 11.558 7.72864 11.1421 7.72864C10.9788 7.72864 10.8208 7.79565 10.5157 7.99426C10.328 8.1167 10.1084 8.2583 9.86328 8.41492C9.65369 8.54846 9.36975 8.67358 9.01904 8.78686C8.67688 8.89758 8.32947 8.95373 7.98645 8.95373C7.64368 8.95373 7.29626 8.89758 6.95386 8.78686C6.60352 8.6737 6.31946 8.54858 6.11023 8.41504C5.86743 8.25989 5.64771 8.11829 5.45715 7.99414C5.15234 7.79553 4.99438 7.72852 4.83105 7.72852C4.41504 7.72852 4.02637 7.79895 3.67566 7.93787C3.32385 8.07715 3.01929 8.26843 2.77039 8.50659C2.53259 8.73413 2.32068 9.01037 2.1405 9.32763C1.9668 9.63342 1.82617 9.95239 1.72266 10.2758C1.62268 10.5884 1.53906 10.9303 1.47412 11.2921C1.40967 11.6507 1.36609 11.991 1.34448 12.3035C1.32324 12.609 1.3125 12.927 1.3125 13.2483C1.3125 14.0835 1.578 14.7596 2.10156 15.2583C2.61865 15.7504 3.30273 15.9999 4.13489 15.9999H11.839C12.6709 15.9999 13.355 15.7504 13.8722 15.2583C14.3959 14.76 14.6614 14.0836 14.6614 13.2482C14.6613 12.9258 14.6504 12.6078 14.629 12.3031ZM13.2257 14.579C12.884 14.9042 12.4304 15.0622 11.8389 15.0622H4.13489C3.54321 15.0622 3.0896 14.9042 2.74805 14.5791C2.41296 14.2601 2.25012 13.8247 2.25012 13.2483C2.25012 12.9485 2.26001 12.6525 2.27979 12.3683C2.29907 12.0895 2.3385 11.7832 2.39697 11.4578C2.45471 11.1363 2.5282 10.8347 2.6156 10.5616C2.69946 10.2998 2.81384 10.0405 2.95569 9.79077C3.09106 9.55273 3.24683 9.34851 3.4187 9.18396C3.57947 9.03003 3.7821 8.90405 4.02087 8.80957C4.2417 8.72217 4.48987 8.67431 4.75928 8.66711C4.79211 8.68457 4.85059 8.71789 4.94531 8.77966C5.13806 8.90527 5.36023 9.04858 5.60583 9.20544C5.88269 9.38195 6.23938 9.54138 6.66553 9.67895C7.1012 9.81982 7.54553 9.89135 7.98657 9.89135C8.42761 9.89135 8.87207 9.81982 9.3075 9.67907C9.73401 9.54126 10.0906 9.38195 10.3678 9.2052C10.6191 9.04455 10.8351 8.90539 11.0278 8.77966C11.1226 8.71802 11.181 8.68457 11.2139 8.66711C11.4834 8.67431 11.7316 8.72217 11.9525 8.80957C12.1912 8.90405 12.3938 9.03015 12.5546 9.18396C12.7264 9.34839 12.8822 9.55261 13.0176 9.79089C13.1595 10.0405 13.274 10.2999 13.3578 10.5615C13.4453 10.835 13.5189 11.1365 13.5765 11.4576C13.6349 11.7837 13.6744 12.0901 13.6937 12.3684V12.3686C13.7136 12.6517 13.7236 12.9476 13.7238 13.2483C13.7236 13.8248 13.5608 14.2601 13.2257 14.579Z"
                                                fill="#0F1030" />
                                        </svg>
                                    </label>
                                    <input type="text" :placeholder="$t('form.first_name')" aria-label="First name"
                                        v-model="firstName">
                                </div>
                                <span class="errorMessage text-danger " v-if="v$.firstName.$error">
                                    {{ v$.firstName.$errors[0].$message }}
                                </span>
                            </div>
                        </div>

                        <!-------City---------
                        <div class="row">
                            <div class="col mb-24">
                                <span class="text-capitalize"> city </span>
                                <div class="form-control position-relative">
                                    <input type="text" :placeholder="$t('form.city')" aria-label="city" v-model="city"
                                        class="w-100 svg-fill mx-2">
                                    <label class="user-first">
                                        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                            viewBox="0 0 24 24">
                                            <path stroke="#0F1030" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="1" d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                            <path stroke="#0F1030" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="1"
                                                d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171c.1.127.2.251.3.371L12 21l5.13-6.248c.194-.209.374-.429.54-.659l.13-.155Z" />
                                        </svg>
                                    </label>
                                </div>
                            </div>
                        </div>-->
                        <!--------Phone Number -------->
                        <div class="row mb-3 mb-24 mt-3">
                            <span class="text-capitalize">{{ $t('phone_number') }}</span>

                            <div style="margin-top: -25px; margin-bottom: 24px;">
                                <div style=" width: 100%;">
                                    <label for="phone"></label>
                                    <TelInput @update-phone="handlePhoneUpdate" />
                                </div>
                                <span class="errorMessage text-danger" v-if="v$.phone.$error">
                                    {{ v$.phone.$errors[0].$message }}
                                </span>
                                <span class="errorMessage text-danger "
                                    v-if="formSubmitted && !v$.phone.$error && !phoneData.valid">
                                    {{ $t('valid_number_error') }}
                                </span>
                            </div>
                        </div>
                        <!--------End of Second Row------------------------->

                        <!--------------Select Gender------------------------------>
                        <div class="row ">
                            <div class="col mb-24 ">
                                <span class="text-capitalize">{{ $t('gender') }}</span>
                                <div class="position-relative">
                                    <select id="genderSelect" class="w-100" v-model="selectedGender">
                                        <option value="" disabled selected>{{ $t('select_gender') }}</option>
                                        <option value="male">{{ $t('male') }}</option>
                                        <option value="female">{{ $t('female') }}</option>
                                    </select>
                                </div>
                                <span class="errorMessage text-danger " v-if="v$.selectedGender.$error">
                                    {{ v$.selectedGender.$errors[0].$message }}
                                </span>
                            </div>
                        </div>
                        <!-----------Start Of Pass---------------------------->
                        <div class="row">
                            <div class="col mb-24 ">
                                <span class="text-capitalize">{{ $t('password') }}</span>
                                <div class="form-control position-relative">
                                    <input :type="showPasswordValue ? 'password' : 'text'" v-model="password"
                                        :placeholder="$t('form.enterPassword')" aria-label="full name" class="w-100">
                                    <label class="user-first">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18"
                                            viewBox="0 0 17 18" fill="none">
                                            <g clip-path="url(#clip0_1392_23741)">
                                                <path
                                                    d="M13.0033 7.7296V5.03742C13.0105 3.81927 12.524 2.64798 11.6554 1.79383C10.8157 0.957706 9.7165 0.5 8.55242 0.5C8.5344 0.5 8.51277 0.5 8.49475 0.5C6.01161 0.503604 3.99338 2.53625 3.99338 5.03742V7.7296C3.05634 7.84132 2.37158 8.62699 2.37158 9.57844V15.6259C2.37158 16.6531 3.19329 17.5 4.22043 17.5H12.7799C13.807 17.5 14.6287 16.6531 14.6287 15.6259V9.57844C14.6251 8.63059 13.9404 7.84132 13.0033 7.7296ZM4.71057 5.03742H4.71417C4.71417 2.93269 6.41165 1.20999 8.49836 1.20999H8.50196C9.49306 1.20638 10.4445 1.59922 11.1473 2.29839C11.8789 3.02279 12.2861 4.01028 12.2789 5.03742V7.7332H11.4861V5.03742C11.4933 4.21931 11.1689 3.43364 10.5887 2.85701C10.0409 2.3092 9.29844 1.99926 8.52359 1.99926H8.50196C6.84413 1.99926 5.50345 3.36156 5.50345 5.03381V7.7332H4.71057V5.03742ZM10.7689 5.03742V7.7332H6.22785V5.03742C6.22785 3.76161 7.24417 2.72366 8.50557 2.72366H8.52719C9.11104 2.72366 9.67326 2.95792 10.0877 3.37238C10.5274 3.81206 10.7761 4.41393 10.7689 5.03742ZM13.9404 15.6367C13.9404 16.2674 13.4286 16.7792 12.7979 16.7792H4.23484C3.60414 16.7792 3.09238 16.2674 3.09238 15.6367V9.59646C3.09238 8.96576 3.60414 8.454 4.23484 8.454H12.7979C13.4286 8.454 13.9404 8.96576 13.9404 9.59646V15.6367Z"
                                                    fill="#0F1030" />
                                                <path
                                                    d="M9.74528 12.3933C9.58671 11.8347 9.07855 11.4526 8.49831 11.4526C7.78111 11.4526 7.19727 12.0329 7.19727 12.7537C7.19727 13.3339 7.57929 13.8421 8.13791 14.0007V15.0098C8.13791 15.208 8.30009 15.3702 8.49831 15.3702C8.69652 15.3702 8.8587 15.208 8.8587 15.0098V14.0007C9.54707 13.8024 9.94711 13.0816 9.74528 12.3933ZM8.49831 13.3303C8.17755 13.3303 7.91806 13.0708 7.91806 12.7501C7.91806 12.4293 8.17755 12.1698 8.49831 12.1698C8.81906 12.1698 9.07855 12.4293 9.07855 12.7501C9.07855 13.0708 8.81906 13.3303 8.49831 13.3303Z"
                                                    fill="#0F1030" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1392_23741">
                                                    <rect width="17" height="17" fill="white"
                                                        transform="translate(0 0.5)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </label>
                                    <span class="input-group-text-fa cursor-pointer">
                                        <span v-if="!showPasswordValue" @click="showPassword">
                                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                                viewBox="0 0 24 24">
                                                <path stroke="currentColor" stroke-linecap="round"
                                                    stroke-linejoin="round" stroke-width="1"
                                                    d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>

                                        </span>

                                        <span v-if="showPasswordValue" @click="hidePassword">
                                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                                viewBox="0 0 24 24">
                                                <path stroke="#ABABAB" stroke-width="1"
                                                    d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z" />
                                                <path stroke="#ABABAB" stroke-width="1"
                                                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>

                                        </span>

                                    </span>
                                </div>
                                <span class="errorMessage text-danger " v-if="v$.password.$error">
                                    {{ v$.password.$errors[0].$message }}
                                </span>
                            </div>
                        </div>
                        <!-------Confirm pass--------------->
                        <div class="row">
                            <div class="col mb-24">
                                <span class="text-capitalize">{{ $t('confirm_password') }}</span>

                                <div class="form-control position-relative">
                                    <input :type="showPasswordValue1 ? 'password' : 'text'" v-model="confirmPass"
                                        :placeholder="$t('form.confirmPassword')" aria-label="full name" class="w-100">
                                    <label class="user-first">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18"
                                            viewBox="0 0 17 18" fill="none">
                                            <g clip-path="url(#clip0_1392_23741)">
                                                <path
                                                    d="M13.0033 7.7296V5.03742C13.0105 3.81927 12.524 2.64798 11.6554 1.79383C10.8157 0.957706 9.7165 0.5 8.55242 0.5C8.5344 0.5 8.51277 0.5 8.49475 0.5C6.01161 0.503604 3.99338 2.53625 3.99338 5.03742V7.7296C3.05634 7.84132 2.37158 8.62699 2.37158 9.57844V15.6259C2.37158 16.6531 3.19329 17.5 4.22043 17.5H12.7799C13.807 17.5 14.6287 16.6531 14.6287 15.6259V9.57844C14.6251 8.63059 13.9404 7.84132 13.0033 7.7296ZM4.71057 5.03742H4.71417C4.71417 2.93269 6.41165 1.20999 8.49836 1.20999H8.50196C9.49306 1.20638 10.4445 1.59922 11.1473 2.29839C11.8789 3.02279 12.2861 4.01028 12.2789 5.03742V7.7332H11.4861V5.03742C11.4933 4.21931 11.1689 3.43364 10.5887 2.85701C10.0409 2.3092 9.29844 1.99926 8.52359 1.99926H8.50196C6.84413 1.99926 5.50345 3.36156 5.50345 5.03381V7.7332H4.71057V5.03742ZM10.7689 5.03742V7.7332H6.22785V5.03742C6.22785 3.76161 7.24417 2.72366 8.50557 2.72366H8.52719C9.11104 2.72366 9.67326 2.95792 10.0877 3.37238C10.5274 3.81206 10.7761 4.41393 10.7689 5.03742ZM13.9404 15.6367C13.9404 16.2674 13.4286 16.7792 12.7979 16.7792H4.23484C3.60414 16.7792 3.09238 16.2674 3.09238 15.6367V9.59646C3.09238 8.96576 3.60414 8.454 4.23484 8.454H12.7979C13.4286 8.454 13.9404 8.96576 13.9404 9.59646V15.6367Z"
                                                    fill="#0F1030" />
                                                <path
                                                    d="M9.74528 12.3933C9.58671 11.8347 9.07855 11.4526 8.49831 11.4526C7.78111 11.4526 7.19727 12.0329 7.19727 12.7537C7.19727 13.3339 7.57929 13.8421 8.13791 14.0007V15.0098C8.13791 15.208 8.30009 15.3702 8.49831 15.3702C8.69652 15.3702 8.8587 15.208 8.8587 15.0098V14.0007C9.54707 13.8024 9.94711 13.0816 9.74528 12.3933ZM8.49831 13.3303C8.17755 13.3303 7.91806 13.0708 7.91806 12.7501C7.91806 12.4293 8.17755 12.1698 8.49831 12.1698C8.81906 12.1698 9.07855 12.4293 9.07855 12.7501C9.07855 13.0708 8.81906 13.3303 8.49831 13.3303Z"
                                                    fill="#0F1030" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1392_23741">
                                                    <rect width="17" height="17" fill="white"
                                                        transform="translate(0 0.5)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </label>
                                    <span class="input-group-text-fa cursor-pointer">

                                        <span v-if="!showPasswordValue1" @click="showPasswordConfirm">
                                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                                viewBox="0 0 24 24">
                                                <path stroke="currentColor" stroke-linecap="round"
                                                    stroke-linejoin="round" stroke-width="1"
                                                    d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>

                                        </span>

                                        <span v-if="showPasswordValue1" @click="hidePasswordConfirm">
                                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                                viewBox="0 0 24 24">
                                                <path stroke="#ABABAB" stroke-width="1"
                                                    d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z" />
                                                <path stroke="#ABABAB" stroke-width="1"
                                                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>
                                        </span>
                                    </span>
                                </div>
                                <span class="errorMessage text-danger " v-if="v$.confirmPass.$error">
                                    {{ v$.confirmPass.$errors[0].$message }}
                                </span>
                            </div>
                        </div>
                        <div class="alert alert-danger" v-if="checkPass"> {{ $t('validations.passwordMatch') }} </div>
                        <!--------End Of Pass-------------->

                        <div class="alert alert-danger mb-3" v-if="serverError">
                            {{ serverError }}
                        </div>
                        <!---------------------------->
                        <button class="main-button d-grid w-100 mb-24 mt-5 fw-500" type="submit">
                            {{ $t('create_account') }}
                        </button>

                    </form>

                </div>
            </div>
        </div>
    </section>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import TelInput from '../common/TelInput';
import DateComponent from '../common/DateComponent.vue';
import { AuthMe, StudentSignUp } from '@/Services/api/AuthService';

export default {
    components: { TelInput, DateComponent },
    data() {
        return {
            selectedGender: "",
            dropdownOpen: false,
            phone: '',
            phoneData: {
                phoneNumber: '',
                countryCode: '',
                valid: false
            },
            firstName: '',
            userEmail: this.$store.getters.getUserEmail || '',
            confirmPass: '',
            password: '',
            city: '',
            showPasswordValue: true,
            showPasswordValue1: true,
            formSubmitted: false,
            checkPass: false,
            identityNumber: '',
            birth: '',
            serverError: ""
        }
    },
    setup() {
        return { v$: useVuelidate() }
    },
    validations() {
        const passwordValidation = helpers.regex(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/
        )
        return {
            firstName: {  required: helpers.withMessage(() => this.$t('validations.required'), required) },
            userEmail: { email: helpers.withMessage(() => this.$t('validations.email'), email),
                        required: helpers.withMessage(() => this.$t('validations.required'), required) },
            phone: {  required: helpers.withMessage(() => this.$t('validations.required'), required) },
            confirmPass: {  required: helpers.withMessage(() => this.$t('validations.required'), required) },
            selectedGender: {  required: helpers.withMessage(() => this.$t('validations.required'), required) },
            password: {
                required: helpers.withMessage(() => this.$t('validations.required'), required),
                passwordValidation: helpers.withMessage(() => this.$t('validations.password'), passwordValidation)
            }
        }
    },
    computed:{
        // userEmailCheck() {
        //     return this.$store.getters.getUserEmail || this.userEmail;
        // }
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },

        // Update phone validation status received from the child component
        handlePhoneUpdate(number, phoneData) {
            this.phone = number;
            this.phoneData.phoneNumber = phoneData.number;
            this.phoneData.countryCode = phoneData.countryCode;
            this.phoneData.valid = phoneData.valid;
        },
        handleUpdateDate(dob) {
            this.birth = dob;
        },
        //Submit Sign up Form
        async submitSignUp() {
            this.v$.$validate();
            this.formSubmitted = true;

            if (!this.v$.$error && this.phoneData.valid) {
                this.checkPass = false;
                if (this.password !== this.confirmPass) {
                    this.checkPass = true;
                } else {
                    const formData = {
                        name: this.firstName,
                        email:  this.userEmail,
                        password: this.password,
                        password_confirmation: this.confirmPass,
                        country_code: this.phoneData.countryCode,
                        gender: this.selectedGender,
                        phone: this.phoneData.phoneNumber,
                        dob: this.birth,
                        city: this.city
                    }

                    this.checkPass = false;
                    try {
                        // Call the userRegister service
                        const response = await StudentSignUp(formData);
                        // Handle successful registration
                        this.serverError = "";
                        this.$store.commit('setAuthenticated', true);
                        this.$store.commit('setUserData', response.data.data.user);
                        this.$store.commit("setAccessToken", response.data.data.token);
                        // Redirect to the external access link
                        if (response.data.data.token) {
                            const userData = await AuthMe();
                            window.location.href = userData.data.data['access_link']; // Redirect to the external URL
                        } else {
                            this.serverError = "An error occurred during redirection.";
                        }
                    } catch (error) {
                        this.serverError = error.message;
                    }
                }
            }
        },
        hidePassword() {
            this.showPasswordValue = false;
        },
        showPassword() {
            this.showPasswordValue = true;
        },
        hidePasswordConfirm() {
            this.showPasswordValue1 = false;
        },
        showPasswordConfirm() {
            this.showPasswordValue1 = true;
        },
    },

}
</script>
<style lang="scss" scoped>
$font-family: Almarai;
$font-weight-normal: 400;
$font-weight-bold: 700;
$color-gray: #c7c7c7;
$color-black: #000;
$color-primary: #206387;
$color-facebook: #3D5A98;
$color-linkedin: #0076B2;
$color-email : #263238;
$color-white : rgba(255, 255, 255, 1);

/******************* */
* {
    &:lang(en) {
        font-family: "poppins", sans-serif;
    }

    &:lang(ar) {
        font-family: "Almarai", serif;
    }
}

.form-group {
    margin: 15px 0;
}

#genderSelect {
    border-bottom: 1px solid #0F1030;
    padding: 15px 0;
    color: #47494a;

    &:focus-visible {
        outline: none;
    }
}

/****************/
.custom-select {
    position: relative;
    width: 100%;
    margin-top: 25px;
}

.selected {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    padding: 18px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #fff;
}

.options {
    position: absolute;
    z-index: 10;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
}

.option {
    display: flex;
    align-items: center;
    padding: 10px;
    gap: 10px;
    cursor: pointer;
}

.option:hover {
    background-color: #f0f0f0;
}

.country-flag {
    width: 20px;
    height: auto;
    margin-right: 8px;
}

/*********************/
.image {
    background-image: url("../../assets/images/home/Hero.svg");
    //background-image: url("../../assets/images/home/sign-up.png");
    background-position: center center;
    background-size: cover;
    height: 100%;
}

a {
    cursor: pointer;
}

.content-login {
    .info {
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        h3,
        p {
            color: var(--Dark-blue, #0F1030);
        }

        h3 {
            margin-top: 24px;
            margin-bottom: 12px;
            font-size: 30px;
            font-weight: 500;
        }

        p {
            font-size: 16px;

            span {
                display: inline-block;
                margin-bottom: 8px;
            }
        }
    }
}

input:focus,
input:focus-visible {
    outline: none;
    border: none !important;
}

/**********************************/
.user-first,
.user-last {
    top: 50%;
}

.user-first,
.user-last,
.user-first-2 {
    position: absolute;
    transform: translateY(-50%);

    &:lang(ar) {
        right: 0px;
    }

    &:lang(en) {
        left: 0px;
    }
}

.user-first-2 {
    top: 57%;
}

label[for="idCard"]~.fa-id-card {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 10px 5px;
}

.fa-id-card {
    font-size: 21px;
    color: #d3d4d4;
}

/********************************/
input[type="email"],
input[type="text"],
input[type="password"],
input[type="tel"] {
    font-size: 18px;

    &:lang(ar) {
        padding: 5px 20px 0 0;
        text-align: right;
    }

    &:lang(en) {
        padding: 5px 0 0 20px;
        text-align: left;
    }

    border:none;
    background: #f8f9fa;

    &::placeholder {
        color: #0F1030;
        font-size: 12px;
        font-weight: $font-weight-normal;
        padding: 0px 5px;
    }
}

input[type="password"] {
    padding: 5px 35px 5px 35px;
}

input[type="text"] {
    width: inherit;
}

.phone-container {
    border: 1px solid #E0E0E0;
}

.label-link {
    color: #0076B2;
    font-size: 14px;
}

/* Move the select icon to the left */
.form-select {
    &:lang(ar) {
        padding-right: 35px;
        border-left: 1px solid $color-gray;
        background-position: left 0.75rem center;
    }

    &:lang(en) {
        padding-left: 35px;
        border-right: 1px solid $color-gray;
        background-position: right 0.75rem center;
    }

    width: 150px;
    font-size: 18px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    // background-image:url(../../../../../assets/images/down-arrow.svg);
    color: $color-gray;
    background-repeat: no-repeat;
    background-size: 1em 1em;
    padding-left: 2.5em;
    border-radius: 0;

    &:focus {
        box-shadow: none !important;
        border-left: 2px solid blue;
    }
}

/*************New Edits**************************************/
.form-control:focus-within {
    border-color: #206387;

    ::placeholder {
        opacity: 0;
    }
}

.mb-24 {
    margin-bottom: 34px;
}

.form-control {
    border: none !important;
    border-bottom: 1px solid #0F1030 !important;
    border-radius: 0 !important;

    &:lang(en) {
        padding-left: 0 !important;
    }

    &:lang(ar) {
        padding-right: 0 !important;
    }
}

input {
    border: none !important;
}

.input-group-text-fa {
    position: absolute;
    top: 11px;
    display: inline-flex;
    align-items: center;
    padding: 0.375rem 0.75rem;
    font-weight: 400;
    line-height: 1.5;

    &:lang(ar) {
        left: 0;
    }

    &:lang(en) {
        right: 0;
    }

    .fa {
        color: #a6a6a6;
        font-size: 16px;
    }
}

.form-check-input:checked,
.form-check-input[type=checkbox]:indeterminate {
    background-color: $color-facebook;
    border-color: $color-facebook;
}

button[type="submit"] {
    font-size: 20px;
    font-weight: $font-weight-bold;
}

.signIn {
    gap: 5px;

    span {
        color: $color-black;
        font-weight: $font-weight-normal;
        font-size: 14px;
    }

    a {
        font-weight: $font-weight-normal;
        font-size: 14px;
        color: #2ea2ce;
    }
}

@media screen and (max-width: 992px) {
    .image {
        display: none;
    }
}

input[type=text] {
    border: none !important;

    &:focus {
        border: none !important;
    }
}
</style>